<template>
    <div>
        <text-heading sub>
            Tags
        </text-heading>
    </div>

    <chip-container>
        <chip-label
            v-for="tag in tags"
            :key="tag"
        >
            {{ tag }}
        </chip-label>
    </chip-container>
</template>

<script setup lang="ts">
    import { ChipContainer, ChipLabel, TextHeading } from '@keyvue/one-ui';
    import { computed } from 'vue';

    const tags = computed(() => [
        'NaBezichtiging',
        'Woningzoeker',
        'NaNieuwbouwGesprek',
        'Facilisis-ullamcorper',
        'Lipsum',
        'Praesent-dictum',
    ]);
</script>
